// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --modal-sm-margin-top: 15vh;
  --modal-md-margin-top: 10vh;
  --modal-lg-margin-top: 6vh;
  --modal-margin-bottom: 10vh;
  --modal-backdrop-background: rgba(0, 0, 0, 0.3);
  --modal-backdrop-transition-duration: var(--default-transition-duration);
  --modal-backdrop-transition-timing: var(--default-transition-timing);
  --modal-backdrop-filter: blur(3px);
  --modal-touch-action: pan-x pan-y;
}

@media screen and (min-width: 430px) {
  .commutably {
    --modal-header-font-size: 1.2em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Modal.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;EAC/C,wEAAwE;EACxE,oEAAoE;EACpE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".commutably {\n  --modal-sm-margin-top: 15vh;\n  --modal-md-margin-top: 10vh;\n  --modal-lg-margin-top: 6vh;\n  --modal-margin-bottom: 10vh;\n  --modal-backdrop-background: rgba(0, 0, 0, 0.3);\n  --modal-backdrop-transition-duration: var(--default-transition-duration);\n  --modal-backdrop-transition-timing: var(--default-transition-timing);\n  --modal-backdrop-filter: blur(3px);\n  --modal-touch-action: pan-x pan-y;\n}\n\n@media (--screen-sm) {\n  .commutably {\n    --modal-header-font-size: 1.2em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
